import { useCallback } from "react";
import {
  setSideMenuExpanded,
  toggleSideMenu,
} from "src/store/slices/sideMenuSlice";
import { useAppDispatch, useAppSelector } from "src/store/store";

export const useSideMenuExpanded = () => {
  const dispatch = useAppDispatch();
  const { isExpanded } = useAppSelector((state) => state.sideMenu);

  const toggle = useCallback(() => {
    dispatch(toggleSideMenu());
  }, [dispatch]);

  const setExpanded = useCallback(
    (expanded: boolean) => {
      dispatch(setSideMenuExpanded(expanded));
    },
    [dispatch]
  );

  return {
    isExpanded,
    toggle,
    setExpanded,
  };
};
